/**
 * Cookie 工具类
 * 提供 cookie 的增删改查功能
 */
class Cookie {
    /**
     * 设置 cookie
     * @param {string} name - cookie 名称
     * @param {string} value - cookie 值
     * @param {number} days - 过期天数，默认为 7 天
     * @param {string} path - 路径，默认为 '/'
     * @param {string} domain - 域名
     */
    setItem(name, value, days = 7, path = '/', domain = '') {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        
        let cookieString = `${name}=${encodeURIComponent(value)}${expires}; path=${path}`;
        if (domain) {
            cookieString += `; domain=${domain}`;
        }
        
        document.cookie = cookieString;
    }

    /**
     * 获取 cookie
     * @param {string} name - cookie 名称
     * @param {string} defaultValue - 默认值
     * @returns {string} cookie 值
     */
    getItem(name, defaultValue = '') {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        
        return defaultValue;
    }

    /**
     * 删除 cookie
     * @param {string} name - cookie 名称
     * @param {string} path - 路径，默认为 '/'
     * @param {string} domain - 域名
     */
    removeItem(name, path = '/', domain = '') {
        this.setItem(name, '', -1, path, domain);
    }

    /**
     * 检查 cookie 是否存在
     * @param {string} name - cookie 名称
     * @returns {boolean} 是否存在
     */
    hasItem(name) {
        return this.getItem(name) !== '';
    }

    /**
     * 获取所有 cookie
     * @returns {object} 所有 cookie 对象
     */
    getAll() {
        const cookies = {};
        const ca = document.cookie.split(';');
        
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            const index = c.indexOf('=');
            if (index > 0) {
                const name = c.substring(0, index);
                const value = c.substring(index + 1, c.length);
                cookies[name] = decodeURIComponent(value);
            }
        }
        
        return cookies;
    }

    /**
     * 清空所有 cookie
     * @param {string} path - 路径，默认为 '/'
     * @param {string} domain - 域名
     */
    clear(path = '/', domain = '') {
        const cookies = this.getAll();
        for (const name in cookies) {
            this.removeItem(name, path, domain);
        }
    }
}

// 创建全局实例
const cookie = new Cookie();

export default cookie;



// WEBPACK FOOTER //
// ./src/util/cookie.js